import { Button, createStyles, Dialog, DialogActions, DialogContent, IconButton, Theme } from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import LabelsContext from "../../../lang/LabelsContext";
import TabReview from "../../private/article-details/tab-review/TabReview";

interface ReviewDialogType {
  articleId: number;
  visible: boolean;
  close: any;
}

export default function ReviewDialog(props: ReviewDialogType) {
  const { articleId, visible, close } = props;

  const { Labels } = LabelsContext();

  const styles = (theme: Theme) =>
    createStyles({
      root: {
        margin: 0,
        padding: theme.spacing(2),
      },
      closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
      },
    });

  const DialogTitle = withStyles(styles)((props: any) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  return (
    <Dialog maxWidth={"md"} fullWidth={true} open={visible} onClose={close} aria-labelledby="form-dialog-title">
      <DialogTitle id="simple-dialog-title" onClose={close}>
        {Labels.REVIEWS}
      </DialogTitle>
      <DialogContent>
        <TabReview editorView={false} articleId={articleId} />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} variant="contained" color="primary">
          {Labels.CANCEL}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
